(() => {
  const PROPERTY_NAME = 'Vendor';

  function getCurrentVendorEntries(root = document) {
    const nodes = root.querySelectorAll('[data-cart-item-key][data-vendor-current]');
    return Array.from(nodes)
      .map((el) => {
        const key = el.getAttribute('data-cart-item-key');
        const vendor = el.getAttribute('data-vendor-current')?.trim() || '';
        return { key, vendor };
      })
      .filter((x) => x.key && x.vendor);
  }

  async function fetchCart() {
    const res = await fetch(`${window.Shopify?.routes?.root || ''}cart.js`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) throw new Error(`Failed to fetch cart.js (${res.status})`);
    return await res.json();
  }

  async function changeLineItemProperties(lineKey, properties) {
    const res = await fetch(`${window.Shopify?.routes?.root || ''}cart/change.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, properties }),
    });
    if (!res.ok) throw new Error(`Failed to cart/change.js (${res.status})`);
    return await res.json();
  }

  async function syncOnce() {
    const desired = getCurrentVendorEntries(document);
    if (!desired.length) return;

    let cart;
    try {
      cart = await fetchCart();
    } catch (e) {
      return;
    }

    const byKey = new Map();
    (cart.items || []).forEach((item) => {
      if (item && item.key) byKey.set(item.key, item);
    });

    const desiredByKey = new Map();
    desired.forEach(({ key, vendor }) => {
      if (byKey.has(key) && !desiredByKey.has(key)) desiredByKey.set(key, vendor);
    });

    for (const [key, vendorNow] of desiredByKey.entries()) {
      const item = byKey.get(key);
      const props = item?.properties || {};
      const vendorStored = (props[PROPERTY_NAME] || '').toString().trim();

      if (vendorStored === vendorNow) continue;

      const nextProps = { ...props, [PROPERTY_NAME]: vendorNow };
      try {
        const updatedCart = await changeLineItemProperties(key, nextProps);
        const stillHasKey = (updatedCart?.items || []).some(i => i.key === key);
        if (!stillHasKey) {
          const newItem = (updatedCart?.items || []).find(
            i => String(i.variant_id) === String(item.variant_id) && !i.properties?._warranty_for
          );
          if (newItem) {
            document.querySelectorAll(`[data-cart-item-key="${CSS.escape(key)}"]`).forEach(el => {
              el.setAttribute('data-cart-item-key', newItem.key);
            });
          }
        }
      } catch (e) {
        // ignore
      }
    }
  }

  let scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(async () => {
      scheduled = false;
      await syncOnce();
    }, 50);
  }

  document.addEventListener('DOMContentLoaded', scheduleSync);
  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('fox:cart:updated', scheduleSync);
  document.addEventListener('cart:updated', scheduleSync);
})();
